import React from 'react';

const CompraTabela = ({ 
  compras, 
  loading, 
  onEditar, 
  onDeletar, 
  onAprovar, 
  onReceber, 
  onCancelar,
  onDetalhes,
  comprasSelecionadas = [],
  onSelecionarCompra,
  onSelecionarTodas
}) => {
  const formatarData = (dataString) => {
    if (!dataString) return '-';
    const data = new Date(dataString);
    return data.toLocaleDateString('pt-BR');
  };

  const getStatusBadge = (status, compra) => {
    const classes = {
      'ABERTA': 'status-aberta',
      'APROVADA': 'status-aprovada',
      'RECEBIDA': 'status-recebida',
      'CANCELADA': 'status-cancelada'
    };
    return (
      <span className={`status-badge ${classes[status] || ''}`}>
        {status}
        {compra?.geradoAutomaticamente ? ' · Automática' : ''}
      </span>
    );
  };

  if (loading) {
    return (
      <div className="loading-container">
        <p>Carregando compras...</p>
      </div>
    );
  }

  if (!compras || compras.length === 0) {
    return (
      <div className="empty-state">
        <p>Nenhuma compra cadastrada</p>
        <p className="empty-state-subtitle">Clique em "Nova Compra" para começar</p>
      </div>
    );
  }

  return (
    <div className="compra-tabela-container">
      <table className="compra-tabela">
        <thead>
          <tr>
            <th className="checkbox-column">
              <input
                type="checkbox"
                checked={compras.length > 0 && comprasSelecionadas.length === compras.length}
                onChange={onSelecionarTodas}
                title="Selecionar todas"
              />
            </th>
            <th>ID</th>
            <th>Fornecedor</th>
            <th>Status</th>
            <th>Data Solicitação</th>
            <th>Data Aprovação</th>
            <th>Data Recebimento</th>
            <th>Valor Total</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {compras.map((compra) => (
            <tr key={compra.id} className={comprasSelecionadas.includes(compra.id) ? 'row-selecionada' : ''}>
              <td className="checkbox-column">
                <input
                  type="checkbox"
                  checked={comprasSelecionadas.includes(compra.id)}
                  onChange={() => onSelecionarCompra(compra.id)}
                />
              </td>
              <td>{compra.id}</td>
              <td>{compra.fornecedorNome || '-'}</td>
              <td>{getStatusBadge(compra.status, compra)}</td>
              <td>{formatarData(compra.dataSolicitacao)}</td>
              <td>{formatarData(compra.dataAprovacao)}</td>
              <td>{formatarData(compra.dataRecebimento)}</td>
              <td>R$ {compra.valorTotal?.toFixed(2) || '0.00'}</td>
              <td className="acoes-cell">
                <div className="acoes-buttons">
                  <button
                    className="btn-acao btn-detalhes"
                    onClick={() => onDetalhes(compra)}
                    title="Ver Detalhes"
                  >
                    👁️ Detalhes
                  </button>
                  {compra.status === 'ABERTA' && (
                    <>
                      <button
                        className="btn-acao btn-aprovar"
                        onClick={() => onAprovar(compra.id)}
                        title="Aprovar"
                      >
                        ✓ Aprovar
                      </button>
                      <button
                        className="btn-acao btn-cancelar-compra"
                        onClick={() => onCancelar(compra.id)}
                        title="Cancelar"
                      >
                        ✗ Cancelar
                      </button>
                    </>
                  )}
                  
                  {compra.status === 'APROVADA' && (
                    <button
                      className="btn-acao btn-receber"
                      onClick={() => onReceber(compra.id)}
                      title="Receber (dar entrada no estoque)"
                    >
                      📦 Receber
                    </button>
                  )}

                  {(compra.status === 'ABERTA' || compra.status === 'APROVADA') && (
                    <button
                      className="btn-acao btn-deletar"
                      onClick={() => onDeletar(compra.id)}
                      title="Deletar"
                    >
                      🗑 Deletar
                    </button>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CompraTabela;
